

interface ICheckboxBoxProps {
  color: string
}

export const CheckboxBox = ({ color }: ICheckboxBoxProps) => (
  <div style={{ width: '32px', height: '32px', border: 'solid 1px #bbb', borderRadius: '8px', background: color }} />
)